import { Listbox, Transition } from '@headlessui/react';
import React, { Fragment } from 'react';
import cx from 'classnames';

interface DateListboxProps {
  onChange: (date: string) => void;
  date: string;
  dates: string[];
  readonly: boolean;
}

export default function DateListbox({ onChange, date, dates, readonly }: DateListboxProps) {
  if (!dates?.length) return <span>No hotel created on event</span>;
  return (
    <Listbox disabled={readonly} value={date} onChange={onChange}>
      <div className={cx('relative w-full md:w-[200px] ', readonly ? 'opacity-70 cursor-not-allowed' : '')}>
        <Listbox.Button className="cms-field person form-control relative text-left  w-[100%_!important]">
          <i className="ri-calendar-line absolute left-2" />
          <span className="truncate mr-3 ml-5 leading-relaxed"> {date && (date as any) !== -Infinity && new Date(date).toISOString()?.replace(/T.*/, '')}</span>
          <i className="ri-arrow-down-s-line absolute right-2" aria-hidden="true" />
        </Listbox.Button>
        <Transition as={Fragment} leave="transition ease-in duration-100" leaveFrom="opacity-100" leaveTo="opacity-0">
          <Listbox.Options className="absolute z-20 ps-0 list-none text-de mt-1 max-h-60 divide-y divide-neutral-200 border border-divider w-full overflow-auto rounded-md bg-white text-base shadow-lg sm:text-sm">
            {dates?.filter(Boolean)?.map((date: any) => (
              <Listbox.Option
                key={date}
                className={({ active }) => `relative cursor-default select-none py-2 px-3  ${active ? 'bg-neutral-300' : 'text-gray-900'}`}
                value={new Date(date).toISOString()?.replace(/T.*/, '')}
              >
                {({ selected }) => (
                  <span className={`block truncate ${selected ? 'font-medium' : 'font-normal'}`}>{new Date(date).toISOString()?.replace(/T.*/, '')}</span>
                )}
              </Listbox.Option>
            ))}
          </Listbox.Options>
        </Transition>
      </div>
    </Listbox>
  );
}
